import React, { ReactChild } from 'react';

const IcYellowWallet: () => ReactChild = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4.5V3a3 3 0 0 1 3-3h11v4.5h4v14H3a3 3 0 0 1-3-3v-11Zm1.5 0h11v-3H3A1.5 1.5 0 0 0 1.5 3v1.5Zm9.5 7.102a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
      fill="#EDB600"
    />
  </svg>
);

export default IcYellowWallet;
